export default function runWhenIdle(cb) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(cb, { timeout: 5000 });
  } else {
    // Safari/Edge fallback
    setTimeout(cb, 1);
  }
}
